<script lang="ts">
	import { onDestroy, onMount } from "svelte";
	import { Unsubscriber } from "svelte/store";
	import { typeModule, generateConfig, formObjectStores } from "./stores/";
	import SerpPage from "./components/serp/SerpPage.svelte";
	import { TypeModule } from "../types/types.serpPage";
	import { readParamFromUrlCategory } from "./modules/url.serpPage";
	import { policyUpdateFormObjectStore } from "./modules/updateFormObjectStorePolicy.serpPage";

	export let categoryList: string;
	export let itemList: string;
	export let itemListName: string;
	export let itemListId: string;
	export let type: TypeModule = "Category";

	generateConfig(type);

	const formObjectStoresUnsubscribe: Unsubscriber = formObjectStores.subscribe(data => {
		policyUpdateFormObjectStore(data);
	});

	onMount(() => {
		typeModule.set(type);
		readParamFromUrlCategory();
		policyUpdateFormObjectStore($formObjectStores);
	});

	onDestroy(formObjectStoresUnsubscribe);
</script>

<SerpPage {type} {categoryList} {itemList} {itemListName} {itemListId} />
